"use client";
// Imports
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import Link from "next/link";
import { Placeholder, Img, Content, AddToMyShowButton } from "@/components";
import { Social } from "@/components/global/footer/Footer";
import { Mail, Globe, X } from "lucide-react";
import { DrawerClose } from "@/components/ui/drawer";

export function CommercialExhibitorDetails({
  data,
  type,
  title,
  categories,
  content,
  locations,
  showAddToMyShow,
  image,
  mapIsActive,
}) {
  return (
    <div
      className="grid lg:h-full h-[90dvh] max-h-[90dvh] overflow-y-auto grid-cols-1 lg:overflow-hidden lg:grid-cols-2"
      style={{
        // Red gum accents instead of theme saddle orange
        "--button-background": "137 33 2",
        "--button-hover-background": "137 33 2",
        "--button-foreground": "255 255 255",
      }}
    >
      <div className="order-last col-span-1 w-full h-full rounded-l-lg text-foreground lg:order-first bg-background">
        <div className="flex flex-col flex-1 justify-between p-4 space-y-3 h-full lg:p-8">
          <div className="pr-2 space-y-5 h-full">
            <h2 className="level-2">{title}</h2>
            {categories?.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {categories?.map((category, index) => (
                  <Label dark={false} key={index}>
                    {category?.title}
                  </Label>
                ))}
              </div>
            )}
            {content && (
              <div className="overflow-y-auto h-full text-sm">
                <div className="space-y-3">
                  <Content content={content} />
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-col">
            <div className="flex gap-3 py-2">
              {data?.facebook && (
                <Social type="facebook" link={data?.facebook} />
              )}
              {data?.instagram && (
                <Social type="instagram" link={data?.instagram} />
              )}
              {data?.company_email && (
                <Link
                  href={`mailto:${data?.company_email}`}
                  className="text-brand-fawn hover:text-brand-orange transition-colors inline-flex"
                  aria-label="Email"
                >
                  <Mail size={28} />
                </Link>
              )}
              {data?.website && (
                <Link
                  className="flex items-center space-x-1 text-brand-fawn hover:text-brand-orange transition-colors"
                  target="_blank"
                  href={`${data?.website}`}
                  aria-label="Website"
                >
                  <Globe size={28} />
                </Link>
              )}
            </div>
          </div>
          {locations?.length > 0 && mapIsActive && (
            <div className="space-y-3">
              <div className="">
                <p className="pb-2">Where to find</p>
                <div className="flex overflow-y-hidden justify-between items-center w-full">
                  <div className="flex flex-wrap gap-2 justify-start w-full">
                    {locations.map((location, index) => (
                      <Button size="xs" key={index} variant="outline">
                        <Link href={`/map?pin=${location?.slug}`}>
                          {location?.title}
                        </Link>
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="relative col-span-1 w-full h-full">
        {data?.discount_code && (
          <div className="absolute right-4 bottom-4 z-50 lg:bottom-8 lg:right-8">
            <div className="box-content px-3 py-1 rounded-full border-2 border-background bg-foreground text-background">
              Discount Code:{" "}
              <span className="font-bold">{data?.discount_code}</span>
            </div>
          </div>
        )}
        <div className="h-[300px] lg:h-full aspect-auto overflow-hidden relative rounded-t-lg lg:rounded-none">
          <DrawerClose asChild>
            <div className="flex absolute top-2 right-2 z-50 justify-center items-center w-8 h-8 rounded-full cursor-pointer lg:hidden bg-foreground text-background">
              <X />
            </div>
          </DrawerClose>
          {image ? (
            <Img className={"object-cover w-full h-full"} data={image} sizes="(max-width: 1024px) 100vw, 500px" />
          ) : (
            <Placeholder type="image-placeholder" />
          )}
        </div>
      </div>
    </div>
  );
}
